import axios from 'utils/axios'
import { VERSIONS } from 'utils/version'

export const getAll = (appid, params) => axios.get(`${VERSIONS.V1}/unity/GetAll`, { params })
  